import { CarouselDotsPropertiesType } from "@website/ui/carousel/carousel.types";

const CarouselDots = ({
  currentSlide,
  currentReference,
  keyCarousel
}: CarouselDotsPropertiesType) => (
  <div className="bg-on-color-disable z-1 absolute bottom-4 right-1/2 flex translate-x-1/2 gap-1 rounded-full px-2.5 py-1">
    {[
      ...Array.from({
        length: currentReference?.track?.details?.slides?.length
      }).keys()
    ]?.map((index) => (
      <div
        className={`size-1.5 rounded-full ${
          currentSlide === index
            ? "bg-on-surface-secondary-high-emphasis"
            : "bg-on-surface-disable-info"
        }`}
        key={`${keyCarousel}-dot-${index}`}
      />
    ))}
  </div>
);

export default CarouselDots;
